import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const SIGNUP_PENDING_KEY = 'supabase.signup-pending';

const AuthCallback = () => {
  const [message, setMessage] = useState('認証処理中…');
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const handleExchange = async () => {
      if (!supabase) {
        if (!isMounted) return;
        setMessage('Supabase クライアントが初期化されていません。');
        return;
      }

      const currentUrl = new URL(window.location.href);
      const searchParams = currentUrl.searchParams;
      const hashParams = new URLSearchParams(currentUrl.hash.replace(/^#/, ''));
      const getParam = (name: string): string | null =>
        searchParams.get(name) ?? hashParams.get(name);

      const errorDescription = getParam('error_description') ?? getParam('error');
      if (errorDescription) {
        setMessage(`エラー: ${errorDescription}`);
        return;
      }

      const authType = getParam('type');

      const codeInSearch = searchParams.get('code');
      const codeInHash = hashParams.get('code');
      const accessToken = hashParams.get('access_token');
      const refreshToken = hashParams.get('refresh_token');

      if (codeInSearch || codeInHash) {
        const exchangeUrl = codeInSearch
          ? currentUrl.toString()
          : `${currentUrl.origin}${currentUrl.pathname}?${hashParams.toString()}`;

        const { error } = await supabase.auth.exchangeCodeForSession(exchangeUrl);

        if (!isMounted) return;

        if (error) {
          setMessage(`エラー: ${error.message}`);
          return;
        }
      } else if (accessToken && refreshToken) {
        const { error } = await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken
        });

        if (!isMounted) return;

        if (error) {
          setMessage(`エラー: ${error.message}`);
          return;
        }
      } else {
        setMessage('エラー: 認証情報が見つかりません。メールリンクが期限切れの可能性があります。');
        return;
      }

      if (!isMounted) return;

      if (authType === 'signup' || authType === 'invite') {
        if (typeof window !== 'undefined') {
          window.sessionStorage.setItem(SIGNUP_PENDING_KEY, 'true');
        }
        setMessage('初回登録のためパスワードを設定してください…');
        navigate('/password-reset/update', { replace: true });
        return;
      }

      if (authType === 'recovery') {
        setMessage('パスワード再設定を続けます...');
        navigate('/password-reset/update', { replace: true });
        return;
      }

      setMessage('サインイン完了。リダイレクトします…');
      navigate('/admin', { replace: true });
    };

    void handleExchange();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return <p>{message}</p>;
};

export default AuthCallback;
